import React from 'react';
import { Typography } from 'antd';
import PostClipsTable from './PostClipsTable';

const { Text } = Typography;

const AIPostClips: React.FC = () => (
  <div>
    <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
      Review AI-generated clips from long-form post uploads.
    </Text>
    <PostClipsTable />
  </div>
);

export default AIPostClips;
